import React from 'react';
import styled from 'styled-components';
import { Box, Flex } from 'grid-styled';
import HomeLogo from './graphics/HomeLogo';

export default () => (
  <Flex
    align='center'
    justify='center'
    m={[2]}
  >
    <Box
      width={[1]}
    >
      <Flex
        align='center'
        justify='center'
      >
        <HomeLogo/>
      </Flex>
    </Box>
  </Flex>
);



// WEBPACK FOOTER //
// ./src/components/HomeBanner.js